import { useAppStore } from "src/state/appStore";

const SCOPE_PREFIX = "aegis";

export const STORAGE_BASE_KEYS = {
	expandedKeys: "expandedKeys",
	selectedCompany: "selectedCompany"
} as const;

export const buildUserScopedKey = (
	tenantName: string | undefined,
	userId: string | number | undefined | null,
	base: string
): string => `${SCOPE_PREFIX}:${tenantName || "tenant"}:${userId ?? "user"}:${base}`;

export function useUserScopedStorageKey(base: string): string {
	const tenantName = useAppStore(s => s.tenantName);
	const userId = useAppStore(s => s.currentUser?.id);
	return buildUserScopedKey(tenantName, userId, base);
}

export const useExpandedKeysStorageKey = (): string => useUserScopedStorageKey(STORAGE_BASE_KEYS.expandedKeys);
export const useSelectedCompanyStorageKey = (): string => useUserScopedStorageKey(STORAGE_BASE_KEYS.selectedCompany);

export function purgeUserScopedStorage(
	tenantName: string | undefined,
	userId: string | number | undefined | null
): void {
	if (!tenantName || userId == null) return;
	const prefix = `${SCOPE_PREFIX}:${tenantName}:${userId}:`;
	removeKeysWhere(k => k.startsWith(prefix));
}

export function purgeLegacyStorageKeys(): void {
	const exact = new Set(["selectedCompany", "rootNode"]);
	removeKeysWhere(k => exact.has(k) || k.endsWith("_expandedKeys") || k.endsWith("_selectedCompany"));
}

function removeKeysWhere(predicate: (key: string) => boolean): void {
	try {
		const doomed: string[] = [];
		for (let i = 0; i < localStorage.length; i++) {
			const k = localStorage.key(i);
			if (k && predicate(k)) doomed.push(k);
		}
		for (const k of doomed) {
			localStorage.removeItem(k);
		}
	} catch {}
}